<!-- section start -->
<section class="p-0">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="error-section">
          <!-- <h1>404</h1> -->
          <h2 style="color: red;">{{message | translate}}</h2>
        </div>
      </div>
    </div>
  </div>
</section>